import React from 'react'
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'react-redux'
import { View } from 'react-native'
import { userSelector } from '@src/selectors/app'
import { StyleService, useStyleSheet } from '@src/style/service'
import { getCoachDescriptor } from '@src/utils'
import { Button, Icon, Text } from '@src/components/base'

const RateCoach = (props: { coachName: string; appointmentId: string }) => {
  const { coachName, appointmentId } = props
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation()
  const user = useSelector(userSelector)
  const coachDescriptor = getCoachDescriptor(user)

  const handleRateCoach = () => {
    navigation.navigate('RateCoachModal', {
      appointmentId,
    })
  }

  const rateYourCoachLabel = `Rate your ${coachDescriptor.capitalized.toString()}`

  return (
    <View style={styles.rateCoachContainer}>
      <Icon name="star" weight="fill" style={styles.star} size={30} />
      <Text type="regular" style={styles.rateCoachText}>
        What did you think about your call with {coachName}?
      </Text>
      <Button
        type="primary"
        size="small"
        accessibilityLabel={rateYourCoachLabel}
        onPress={handleRateCoach}
      >
        {rateYourCoachLabel}
      </Button>
    </View>
  )
}

export { RateCoach }

const themedStyles = StyleService.create({
  rateCoachContainer: {
    backgroundColor: 'theme.surface.base3',
    borderWidth: 2,
    borderRadius: 12,
    borderColor: 'theme.surface.base1',
    paddingVertical: 24,
    paddingHorizontal: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rateCoachText: {
    textAlign: 'center',
    marginBottom: 16,
  },
  star: {
    color: 'theme.marketing.yellow',
    marginBottom: 16,
  },
})
